module.exports = __webpack_public_path__ + "img/personback.576c00c2.png";